module.exports = __webpack_public_path__ + "img/search.4d7e3a28.svg";